import { cn } from "@/modules/lib/utils"
import { BoxSlotListSlider } from "@/modules/boxSlot/components/boxSlotListSlider"
import { BoxSlotInfoDetails } from "@/modules/boxSlot/components/boxSlotInfoDetails"

type BoxSlotInfoWrapperProps = {
  boxSlotId: string
  destinationView?: "session"
  className?: string
} & React.ComponentProps<"div">

export function BoxSlotInfoWrapper({ boxSlotId, destinationView, className, ...props }: BoxSlotInfoWrapperProps) {
  return (
    <div className={cn("flex w-full flex-col gap-4 pt-14", className)} {...props}>
      <BoxSlotListSlider boxSlotId={boxSlotId} />
      <BoxSlotInfoDetails destinationView={destinationView} />
    </div>
  )
}
